import { render, staticRenderFns } from "./FrameWithBack.vue?vue&type=template&id=8f83eaea&scoped=true"
import script from "./FrameWithBack.vue?vue&type=script&lang=js"
export * from "./FrameWithBack.vue?vue&type=script&lang=js"
import style0 from "./FrameWithBack.vue?vue&type=style&index=0&id=8f83eaea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f83eaea",
  null
  
)

export default component.exports